/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Cl_Proof_TitleInputs */

const en_st_cl_proof_title = /** @type {(inputs: St_Cl_Proof_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proof summary`)
};

const id_st_cl_proof_title = /** @type {(inputs: St_Cl_Proof_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringkasan bukti`)
};

/**
* | output |
* | --- |
* | "Proof summary" |
*
* @param {St_Cl_Proof_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_cl_proof_title = /** @type {((inputs?: St_Cl_Proof_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Cl_Proof_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_cl_proof_title(inputs)
	return en_st_cl_proof_title(inputs)
});